export default {
  text: '#111',
  background: '#fefefe',
  primary: '#000',
  secondary: '#000',
  light: '#FFF',
};
